var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { row: "", "justify-content-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("保存しますか?"),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _c(
                  "div",
                  { attrs: { "grid-list-md": "" } },
                  _vm._l(
                    _vm.questionComparisons,
                    function (questionComparison, index) {
                      return _c(
                        "div",
                        { key: index, attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("label", [
                                _vm._v("Question " + _vm._s(index + 1)),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                questionComparison.changeLogs,
                                function (changeLog, i) {
                                  return _c("div", { key: i }, [
                                    _c("span", { staticClass: "change" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(changeLog.change) +
                                          "\n                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "before" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(changeLog.before) +
                                          "\n                "
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                ｰ>\n                "
                                    ),
                                    _c("span", { staticClass: "after" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(changeLog.after) +
                                          "\n                "
                                      ),
                                    ]),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onCancel()
                        },
                      },
                    },
                    [_vm._v("キャンセル")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onSave()
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }